var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-row",
        [
          _c(
            "el-row",
            { staticStyle: { height: "50px", overflow: "hidden" } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("span", { staticClass: "params-title" }, [
                  _vm._v(_vm._s(_vm.$t("panel.inner_padding"))),
                ]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      max: 50,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.themeChange("innerPadding")
                      },
                    },
                    model: {
                      value: _vm.commonBackground.innerPadding,
                      callback: function ($$v) {
                        _vm.$set(_vm.commonBackground, "innerPadding", $$v)
                      },
                      expression: "commonBackground.innerPadding",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { height: "50px", overflow: "hidden" } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("span", { staticClass: "params-title" }, [
                  _vm._v(_vm._s(_vm.$t("panel.board_radio"))),
                ]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.themeChange("borderRadius")
                      },
                    },
                    model: {
                      value: _vm.commonBackground.borderRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.commonBackground, "borderRadius", $$v)
                      },
                      expression: "commonBackground.borderRadius",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { height: "40px", overflow: "hidden" } },
            [
              _c(
                "el-col",
                { staticStyle: { "padding-top": "5px" }, attrs: { span: 6 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.themeChange("backgroundColorSelect")
                        },
                      },
                      model: {
                        value: _vm.commonBackground.backgroundColorSelect,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.commonBackground,
                            "backgroundColorSelect",
                            $$v
                          )
                        },
                        expression: "commonBackground.backgroundColorSelect",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("chart.color")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "padding-top": "5px" }, attrs: { span: 3 } },
                [
                  _c("el-color-picker", {
                    staticClass: "color-picker-style",
                    attrs: {
                      disabled: !_vm.commonBackground.backgroundColorSelect,
                      size: "mini",
                      predefine: _vm.predefineColors,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.themeChange("color")
                      },
                    },
                    model: {
                      value: _vm.commonBackground.color,
                      callback: function ($$v) {
                        _vm.$set(_vm.commonBackground, "color", $$v)
                      },
                      expression: "commonBackground.color",
                    },
                  }),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 5 } }, [
                _c("span", { staticClass: "params-title-small" }, [
                  _vm._v(_vm._s(_vm.$t("chart.not_alpha"))),
                ]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-slider", {
                    attrs: {
                      disabled: !_vm.commonBackground.backgroundColorSelect,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.themeChange("alpha")
                      },
                    },
                    model: {
                      value: _vm.commonBackground.alpha,
                      callback: function ($$v) {
                        _vm.$set(_vm.commonBackground, "alpha", $$v)
                      },
                      expression: "commonBackground.alpha",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { height: "50px" } },
            [
              _c(
                "el-col",
                { staticStyle: { "padding-top": "5px" }, attrs: { span: 4 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.themeChange("enable")
                        },
                      },
                      model: {
                        value: _vm.commonBackground.enable,
                        callback: function ($$v) {
                          _vm.$set(_vm.commonBackground, "enable", $$v)
                        },
                        expression: "commonBackground.enable",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("panel.background")) + "\n        ")]
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 20 } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#909399",
                      "font-size": "8px",
                      "margin-left": "10px",
                      "line-height": "40px",
                    },
                  },
                  [
                    _vm._v(
                      "\n          Tips:" +
                        _vm._s(_vm.$t("panel.choose_background_tips")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm.commonBackground.enable
            ? _c(
                "el-row",
                { staticStyle: { "padding-left": "10px" } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        height: "80px",
                        "margin-top": "0px",
                        "margin-bottom": "20px",
                        overflow: "hidden",
                      },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "outerImage" },
                              on: {
                                change: function ($event) {
                                  return _vm.themeChange("backgroundType")
                                },
                              },
                              model: {
                                value: _vm.commonBackground.backgroundType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.commonBackground,
                                    "backgroundType",
                                    $$v
                                  )
                                },
                                expression: "commonBackground.backgroundType",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.photo")) + "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticStyle: { width: "130px!important" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              class: { disabled: _vm.uploadDisabled },
                              attrs: {
                                action: "",
                                accept: ".jpeg,.jpg,.png,.gif,.svg",
                                "list-type": "picture-card",
                                "on-preview": _vm.handlePictureCardPreview,
                                "on-remove": _vm.handleRemove,
                                "http-request": _vm.upload,
                                "file-list": _vm.fileList,
                              },
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                          _c(
                            "el-dialog",
                            {
                              attrs: {
                                top: "25vh",
                                width: "600px",
                                "append-to-body": true,
                                "destroy-on-close": true,
                                visible: _vm.dialogVisible,
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.dialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.dialogImageUrl,
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { staticStyle: { position: "relative" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "innerImage" },
                              on: {
                                change: function ($event) {
                                  return _vm.themeChange("backgroundType")
                                },
                              },
                              model: {
                                value: _vm.commonBackground.backgroundType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.commonBackground,
                                    "backgroundType",
                                    $$v
                                  )
                                },
                                expression: "commonBackground.backgroundType",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.board")) + "\n          "
                              ),
                            ]
                          ),
                          _c("el-color-picker", {
                            staticClass: "color-picker-style",
                            staticStyle: {
                              position: "absolute",
                              left: "60px",
                              top: "-3px",
                            },
                            attrs: {
                              title: _vm.$t("panel.border_color_setting"),
                              size: "mini",
                              predefine: _vm.predefineColors,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.themeChange("innerImageColor")
                              },
                            },
                            model: {
                              value: _vm.commonBackground.innerImageColor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.commonBackground,
                                  "innerImageColor",
                                  $$v
                                )
                              },
                              expression: "commonBackground.innerImageColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { staticClass: "main-row", style: _vm.customStyle },
                        _vm._l(_vm.BackgroundShowMap, function (value, key) {
                          return _c(
                            "el-row",
                            { key: key },
                            _vm._l(value, function (item) {
                              return _c(
                                "el-col",
                                { key: item.id, attrs: { span: 12 } },
                                [
                                  _c("background-item-overall", {
                                    attrs: {
                                      "common-background": _vm.commonBackground,
                                      template: item,
                                    },
                                    on: {
                                      borderChange: function ($event) {
                                        return _vm.themeChange("innerImage")
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }